import { ROUTER_PATH } from "@config/router";
import { closeActiveChatOverlay } from "@utils/chatUtils/closeActiveChatOverlay";

/** 与 `MemberKeys.PRICING` 对齐，避免 utils 依赖 Member 屏幕模块 */
export const MEMBER_PRICING_TAB = "pricing";

export type MemberPricingNavigationRouter = {
  push: (href: string) => void;
  replace?: (href: string) => void;
};

export type NavigateToMemberPricingPageOptions = {
  tab?: string;
  planId?: string;
  replace?: boolean;
};

/** `/member?tab=pricing`（可选 planId） */
export function buildMemberPricingHref(
  options?: Pick<NavigateToMemberPricingPageOptions, "tab" | "planId">,
): string {
  const tab = options?.tab ?? MEMBER_PRICING_TAB;
  const params = new URLSearchParams({ tab });
  if (options?.planId) {
    params.set("planId", options.planId);
  }
  return `${ROUTER_PATH.MEMBER}/?${params.toString()}`;
}

/**
 * 离开 Chat overlay 后再跳会员 Pricing。
 * 关闭逻辑与 `useOpenChatModal` 的 `onCloseClick` 一致；导航在关闭动画结束后执行。
 */
export function closeChatOverlayBeforeMemberNavigation(
  onClosed?: () => void,
): void {
  closeActiveChatOverlay({ onClosed });
}

export function navigateToMemberPricingPage(
  router: MemberPricingNavigationRouter,
  options?: NavigateToMemberPricingPageOptions,
): void {
  const href = buildMemberPricingHref(options);

  closeChatOverlayBeforeMemberNavigation(() => {
    if (options?.replace && router.replace) {
      router.replace(href);
      return;
    }
    router.push(href);
  });
}
